import { CrudService } from "@/services/crudService";
import { config } from "@/services/configService";
type PublicInfoPayload = {
  googleMapsApiKey?: unknown;
  GoogleMapsApiKey?: unknown;
  data?: unknown;
  Data?: unknown;
};

type PublicInfoResult = {
  googleMapsApiKey: string | null;
};

function normalizeString(value: unknown): string | null {
  if (typeof value !== "string") {
    return null;
  }
  const trimmed = value.trim();
  return trimmed ? trimmed : null;
}

function extractGoogleMapsApiKey(payload: unknown): string | null {
  if (!payload || typeof payload !== "object") {
    return null;
  }
  const direct = payload as PublicInfoPayload;
  const directLowerKey = normalizeString(direct.googleMapsApiKey);
  if (directLowerKey) {
    return directLowerKey;
  }
  const directKey = normalizeString(direct.GoogleMapsApiKey);
  if (directKey) {
    return directKey;
  }
  const nested = direct.data || direct.Data;
  if (!nested || typeof nested !== "object") {
    return null;
  }
  const nestedPayload = nested as PublicInfoPayload;
  const nestedLowerKey = normalizeString(nestedPayload.googleMapsApiKey);
  if (nestedLowerKey) {
    return nestedLowerKey;
  }
  const nestedKey = normalizeString(nestedPayload.GoogleMapsApiKey);
  return nestedKey ? nestedKey : null;
}

let pendingLoad: Promise<PublicInfoResult> | null = null;
let cachedPublicInfo: PublicInfoResult | null = null;

export async function loadPublicInfo(): Promise<PublicInfoResult> {
  if (cachedPublicInfo) {
    return cachedPublicInfo;
  }
  if (pendingLoad) {
    return pendingLoad;
  }
  const crud = new CrudService({
    baseUrl: config.apiUrl,
    allowAuth: false,
    handleUnauthorized: false,
  });
  pendingLoad = (async (): Promise<PublicInfoResult> => {
    try {
      const response = await crud.httpGet(
        "/configs/maps-key",
        null,
        undefined,
        "json",
        {
          headers: {
            Accept: "*/*",
          },
        },
      );
      const googleMapsApiKey = extractGoogleMapsApiKey(response);
      loadGoogleMaps(googleMapsApiKey);
      const result = {
        googleMapsApiKey,
      };
      cachedPublicInfo = result;
      pendingLoad = null;
      return result;
    } catch (error) {
      pendingLoad = null;
      return {
        googleMapsApiKey: null,
      };
    }
  })();
  return pendingLoad;
}

export function loadGoogleMaps(apiKey: string | null) {
  return new Promise<void>((resolve, reject) => {
    const t: any = (window as any).google;
    if (t?.maps) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&loading=async`;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = reject;

    document.head.appendChild(script);
  });
}
